function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

/*
Copyright (c) Uber Technologies, Inc.

This source code is licensed under the MIT license found in the
LICENSE file in the root directory of this source tree.
*/
// BASEUI-GENERATED-FLAG-COMPONENT
// DO NOT EDIT THIS FILE DIRECTLY
import * as React from 'react';
export default function FlagNG(props) {
  return /*#__PURE__*/React.createElement("img", _extends({
    src: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAD8AAAAtBAMAAADrb658AAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAAVUExURRKKVRSRWxeYX/39/fj4+PPz8/Hx8QtazJ4AAAFXSURBVDjL7Y7BccMgEEWXg3IGhtyNUoLpAOhAqAOp/xLy/2KhOGPllEtm8i1k2H08rcwjH/eRs3iTf+AayBdAPvJk8D0xRhoSn5znUb0JOrPHL56GdI84zjNaADz63kXnfci5pHtJKZcYPYt48RMEQbmQ0CyJmLZndqyAI4pFwyO9hHgr6ucXPAyFhpKLe3zAOxj6/ehcKMOgdw6D68EMpROwsNAHpeFAAlqHYRQJkO5AOQH3DLjfBOorwDqDJ1QEBF56Zt2JGGv1AMNCAQ1Lv4y+gcHwzxpjwqKhwTKOS0S3hp7Q6tJqBdNQ6GYLg94G7t61VwtWHwqIIEZpmCa2sRAcTXejj41CZmKrqcboEKiJorqxMkGAH8MqxuN1PI+9paE2pXCh3+IQp6GNiE73LTAsAxB1dM4c+FfDy0zbvqO5r1fAW9tWpG37egHszIbsPwGavwZ8Avvmv2+6yjjwAAAAAElFTkSuQmCC",
    alt: "NG"
  }, props));
}